module.exports = __webpack_public_path__ + "static/media/forehead.42a534eb.svg";